import { Icon } from '@/hen-ui/atomics/Icon';
import { Text } from '@/hen-ui/atomics/Text';
import { Flex } from '@/hen-ui/composites/Flex';

import type { CareerExplorerRecommendationDetail } from './types';

export const CareerExplorerRecommendationDetailItem = ({
  icon,
  label,
}: CareerExplorerRecommendationDetail) => (
  <Flex direction='row' gap='xxs' align='center'>
    <Icon icon={icon} size='sm' strokeWidth={2.5} aria-hidden />
    <Text
      tag='span'
      variant='l1'
      className='-mb-0.5 whitespace-nowrap text-neutral-700'
    >
      {label}
    </Text>
  </Flex>
);
